import { IdentityService } from '../services/IdentityService';
import { Store, AnyAction } from 'redux';
import * as Actions from '../actions/ActionsIndex';
import { IUserInfo } from 'src/models/IUserInfo';


export class StoreInitializer {
    constructor(private store: Store<{}, AnyAction>) {
        this.OnGetProfileInfoSuccess = this.OnGetProfileInfoSuccess.bind(this);
        this.OnGetProfileInfoError = this.OnGetProfileInfoError.bind(this);
        this.OnGetClientStateSuccess = this.OnGetClientStateSuccess.bind(this);
        this.OnGetClientStateError = this.OnGetClientStateError.bind(this);
    }

    public InitializeStore(): void {
        this.InitializeIdentityStore();
    }

    private InitializeIdentityStore(): void {
        let service = new IdentityService();
        service.GetProfileInfo(this.OnGetProfileInfoSuccess, this.OnGetProfileInfoError);
    }

    private OnGetProfileInfoSuccess(result: IUserInfo): void {
        this.store.dispatch(Actions.SetProfileInfo(result));
    }

    private OnGetProfileInfoError(status: number, error: string): void {
        console.error(error);
    }

    private OnGetClientStateSuccess(result) {
    }

    private OnGetClientStateError(error) {
        console.error(error);
    }
}



// WEBPACK FOOTER //
// ./src/stores/StoreInitializer.tsx